export const scrollbarStyles =
  "scrollbar-thin scrollbar-thumb-border-strong scrollbar-track-transparent";
